// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { installApiFetchInterceptor } from './config/api';

document.documentElement.lang = 'en-GB';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#ea0a0c',
    },
    secondary: {
      main: '#e8ae1c',
    },
    info: {
      main: '#000',
    },
  },
  typography: {
    fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(','),
  },
});

installApiFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
);
